import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import deTranslation from './locales/de/translation.json';
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import frTranslation from './locales/fr/translation.json';
import jaTranslation from './locales/ja/translation.json';
import ruTranslation from './locales/ru/translation.json';
import zhTranslation from './locales/zh/translation.json';
import { legalDocumentsDe } from './locales/documents/de';
import { legalDocumentsEn } from './locales/documents/en';
import { legalDocumentsEs } from './locales/documents/es';
import { legalDocumentsFr } from './locales/documents/fr';
import { legalDocumentsJa } from './locales/documents/ja';
import { legalDocumentsRu } from './locales/documents/ru';
import { legalDocumentsZh } from './locales/documents/zh';
import { APP_LOCALES, getInitialAppLocale } from './i18n/languagePreference';

function withLegalDocuments<T extends { legal: Record<string, unknown> }>(
  translation: T,
  docs: { termsFull: string; privacyFull: string }
): T {
  return {
    ...translation,
    legal: { ...translation.legal, ...docs },
  };
}

const resources = {
  en: { translation: withLegalDocuments(enTranslation, legalDocumentsEn) },
  es: { translation: withLegalDocuments(esTranslation, legalDocumentsEs) },
  ru: { translation: withLegalDocuments(ruTranslation, legalDocumentsRu) },
  de: { translation: withLegalDocuments(deTranslation, legalDocumentsDe) },
  fr: { translation: withLegalDocuments(frTranslation, legalDocumentsFr) },
  ja: { translation: withLegalDocuments(jaTranslation, legalDocumentsJa) },
  zh: { translation: withLegalDocuments(zhTranslation, legalDocumentsZh) },
} as const;

const supportedLngs = [...APP_LOCALES.map((l) => l.code), 'cimode'];

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialAppLocale(),
  fallbackLng: 'en',
  supportedLngs,
  nonExplicitSupportedLngs: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n; 